/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPasswordresetChangePost } from '../fn/password-reset/api-passwordreset-change-post';
import { ApiPasswordresetChangePost$Params } from '../fn/password-reset/api-passwordreset-change-post';
import { apiPasswordresetResetPost } from '../fn/password-reset/api-passwordreset-reset-post';
import { ApiPasswordresetResetPost$Params } from '../fn/password-reset/api-passwordreset-reset-post';
import { apiPasswordresetSendResetEmailPost } from '../fn/password-reset/api-passwordreset-send-reset-email-post';
import { ApiPasswordresetSendResetEmailPost$Params } from '../fn/password-reset/api-passwordreset-send-reset-email-post';
import { apiPasswordresetVerifyPasswordResetLinkPost } from '../fn/password-reset/api-passwordreset-verify-password-reset-link-post';
import { ApiPasswordresetVerifyPasswordResetLinkPost$Params } from '../fn/password-reset/api-passwordreset-verify-password-reset-link-post';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class PasswordResetService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPasswordresetSendResetEmailPost()` */
  static readonly ApiPasswordresetSendResetEmailPostPath = '/api/passwordreset/send-reset-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPasswordresetSendResetEmailPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetSendResetEmailPost$Response(params?: ApiPasswordresetSendResetEmailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiPasswordresetSendResetEmailPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPasswordresetSendResetEmailPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetSendResetEmailPost(params?: ApiPasswordresetSendResetEmailPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiPasswordresetSendResetEmailPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiPasswordresetVerifyPasswordResetLinkPost()` */
  static readonly ApiPasswordresetVerifyPasswordResetLinkPostPath = '/api/passwordreset/verify-password-reset-link';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPasswordresetVerifyPasswordResetLinkPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetVerifyPasswordResetLinkPost$Response(params?: ApiPasswordresetVerifyPasswordResetLinkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiPasswordresetVerifyPasswordResetLinkPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPasswordresetVerifyPasswordResetLinkPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetVerifyPasswordResetLinkPost(params?: ApiPasswordresetVerifyPasswordResetLinkPost$Params, context?: HttpContext): Observable<void> {
    return this.apiPasswordresetVerifyPasswordResetLinkPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiPasswordresetResetPost()` */
  static readonly ApiPasswordresetResetPostPath = '/api/passwordreset/reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPasswordresetResetPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetResetPost$Response(params?: ApiPasswordresetResetPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiPasswordresetResetPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPasswordresetResetPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetResetPost(params?: ApiPasswordresetResetPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiPasswordresetResetPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiPasswordresetChangePost()` */
  static readonly ApiPasswordresetChangePostPath = '/api/passwordreset/change';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPasswordresetChangePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetChangePost$Response(params?: ApiPasswordresetChangePost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiPasswordresetChangePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPasswordresetChangePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPasswordresetChangePost(params?: ApiPasswordresetChangePost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiPasswordresetChangePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

}
